import { Router } from '@angular/router';
import { Component, Input } from '@angular/core';

import { AuthLogoutService } from '../app/service/auth-logout/auth-logout.service';
import { CommonService } from '../app/service/common/common.service';

@Component({
  selector: 'error-info',
  template: `
    <section *ngIf="message != null && message.length &gt; 0">
      <div class="error error-messageHead error-messageHead__business">
        <div class="error-messageHead__title">
          <svg class="icon icon-sign"><use xlink:href="../../../../assets/fonts/icomoon/symbol-defs.svg#icon-sign"></use></svg> {{ message }}
        </div>
      </div>
    </section>
  `
})
export class ErrorInfoComponent {
  @Input() message: string;

  constructor(
    private router: Router,
    private authLogoutService: AuthLogoutService,
    private commonService: CommonService
    ) {}

  ngOnChanges(){
    // エラーメッセージが「認証が必要です」の場合にログアウト
    if(this.message === '認証が必要です。'){
      this.logout();
    }
  }

  logout(){
    this.authLogoutService
    .post()
    .then(() => {
      sessionStorage.clear();
      this.router.navigate(['wa0001']);
    })
    .catch(error => {
      sessionStorage.clear();
      this.router.navigate(['wa0001']);
      console.log(this.commonService.getErrorMessage(error));
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/component/error-info.component.ts